<template>
  <Countdown :seconds="seconds" @finish="countdownFinished" @start="start" />
  <div v-if="!started">GOAL: <input type="number" v-model="goal" /></div>
  <div v-if="started">Correct: {{ achieved }}; goal: {{ goal }}</div>
  <!-- <div>Score: {{ score }}</div> -->
  <div id="container">
    <div id="top">
      <div class="text">The number is even</div>
      <div class="flex">
        <div class="center">
          <img class="rotate arrow" src="@/assets/arrow.svg" alt="" /> wrong
        </div>
        <div class="big">
          <div>
            <span :class="color[0]">{{ top[0] }}</span>
            <span :class="color[1]">{{ top[1] }}</span>
          </div>
        </div>
        <div class="center">
          <img class="arrow" src="@/assets/arrow.svg" alt="" /> correct
        </div>
      </div>
    </div>
    <div id="bottom">
      <div class="text">The letter is uppercase</div>
      <div class="flex">
        <div class="center">
          <img class="rotate arrow" src="@/assets/arrow.svg" alt="" /> correct
        </div>
        <div class="big">
          <div>
            <span :class="color[0]">{{ bottom[0] }}</span>
            <span :class="color[1]">{{ bottom[1] }}</span>
          </div>
        </div>
        <div class="center">
          <img class="arrow" src="@/assets/arrow.svg" alt="" /> wrong
        </div>
      </div>
    </div>
    <img
      v-if="correct"
      class="correct"
      src="@/assets/check.svg"
      alt="correct"
    />
    <img v-if="wrong" class="wrong" src="@/assets/x.svg" alt="wrong" />
  </div>
</template>

<script>
import Countdown from "./Countdown.vue";

const buchstaben = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const nummern = "0123456789";

export default {
  name: "Letter",
  components: {
    Countdown,
  },
  data() {
    return {
      started: false,
      top: [],
      bottom: [],
      color: [],
      numberAt: -1,
      score: 0,
      finish: false,
      seconds: 45,
      correct: false,
      wrong: false,
      solvedTimer: {},
      goal: 30,
      achieved: 0,
    };
  },
  methods: {
    initTimer(which) {
      clearTimeout(this.solvedTimer);

      if (which === "correct") {
        this.correct = true;
        this.wrong = false;
      } else {
        this.correct = false;
        this.wrong = true;
      }

      this.solvedTimer = setTimeout(() => {
        this.correct = false;
        this.wrong = false;
      }, 1000);
    },
    countdownFinished() {
      this.finish = true;
      console.log("countdownFinished");
    },
    updateScore(n) {
      if (n > 0) this.achieved++;
      if (n < 0) this.achieved--;
      this.score += n;
    },
    start() {
      this.started = true;
      this.init();
    },
    init() {
      this.top = [];
      this.bottom = [];
      this.color = [];
      this.numberAt = -1;
      this.score = 0;
      this.initKeyboard();
      this.generateNewCombination();
      // var text = this.getRandomNumber() + "" + this.getRandomLetter();
      // this.top = text;
    },
    won() {
      console.log("win");
      //win animation TODO
    },
    loose() {
      console.log("win");
      this.reload();
    },
    reset() {
      //reset variables
      this.top = "";
      this.bottom = "";
      this.score = 0;
    },
    getRandomLetter() {
      return buchstaben.charAt(Math.floor(Math.random() * buchstaben.length));
    },
    getRandomNumber() {
      return nummern.charAt(Math.floor(Math.random() * nummern.length));
    },
    checkTop(answer) {
      // console.log(answer);
      // console.log(this.top);
      // console.log(this.numberAt);
      // console.log(this.top[this.numberAt]);
      // console.log(this.top[this.numberAt] % 2);
      if (this.top[this.numberAt] % 2 == 0 && answer === "correct") {
        console.log("correct");
        this.updateScore(10);
        this.initTimer("correct");
        return;
      } else if (this.top[this.numberAt] % 2 != 0 && answer === "wrong") {
        this.updateScore(10);
        this.initTimer("correct");
        return;
      }
      this.updateScore(-10);
      this.initTimer("wrong");
    },
    testUpperCase(n) {
      return /\p{Lu}/u.test(n);
    },
    checkBottom(answer) {
      //answers are reversed!
      var letterAt = 0;
      if (this.numberAt === 0) letterAt = 1;
      if (this.testUpperCase(this.bottom[letterAt]) && answer === "wrong") {
        console.log("correct");
        this.updateScore(10);
        this.initTimer("correct");
        return;
      } else if (
        !this.testUpperCase(this.bottom[letterAt]) &&
        answer === "correct"
      ) {
        this.updateScore(10);
        this.initTimer("correct");
        return;
      }
      this.updateScore(-10);
      this.initTimer("wrong");
    },
    keyBoardPress(answer) {
      if (this.top.length > 0) {
        this.checkTop(answer);
      } else {
        this.checkBottom(answer);
      }
      this.generateNewCombination();
    },
    generateNewCombination() {
      var colors = ["", "red"];
      if (Math.floor(Math.random() * 2) % 2) {
        colors = ["red", ""];
      }

      var where = Math.floor(Math.random() * 2);
      let text = [];
      if (where === 0) {
        text[0] = this.getRandomNumber();
        text[1] = this.getRandomLetter();
        this.numberAt = 0;
      } else {
        text[0] = this.getRandomLetter();
        text[1] = this.getRandomNumber();
        // text = this.getRandomLetter() + "" + this.getRandomNumber();
        this.numberAt = 1;
      }

      //set the text and color
      if (this.top.length > 0) {
        this.top = [];
        this.bottom = text;
        if (this.achieved > 5) {
          this.color = colors;
        }
      } else {
        this.bottom = [];
        this.top = text;
        if (this.achieved > 5) {
          this.color = colors;
        }
      }
    },
    initKeyboard() {
      window.addEventListener("keydown", (event) => {
        if (this.finish) return;
        event.preventDefault();
        if (this.keyPressed) return;
        this.keyPressed = true;
        // console.log(event.code);
        if (event.code === "ArrowLeft") {
          this.keyBoardPress("wrong");
        }
        if (event.code === "ArrowRight") {
          this.keyBoardPress("correct");
        }
      });

      window.addEventListener("keyup", () => {
        this.keyPressed = false;
      });
    },
  },
  created() {},
};
</script>

<style scoped>
.red {
  color: red;
}

.correct,
.wrong {
  position: absolute;
  width: 100px;
  left: 50%;
  top: 49%;
  transform: translate(-50%, -50%);
}
.flex {
  display: flex;
  height: 60%;
  align-items: center;
}

.text {
  margin: 20px;
}

.center {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.arrow {
  width: 80px;
}

.rotate {
  transform: rotate(180deg);
}

.big {
  font-size: 100px;
  width: 80%;
  height: 100%;
  border: 1px solid;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

#container {
  width: 500px;
  height: 500px;
  border: 2px solid;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

#top,
#bottom {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
}
</style>
